<template>
  <div class="expandable-box">
    <!-- Gray title box -->
    <button @click="toggleExpanded" class="title-box">
      <h3>{{(isExpanded?'- ':'+ ')+ title }}</h3>
    </button>


    <!-- White description box (only shown when expanded) -->
    <div v-if="isExpanded" class="description-box" ref="description">

    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandableBox',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
      if(this.isExpanded){
        setTimeout(()=>{this.displayDescription()}, 100)
      }
    },
    displayDescription(){
      let description=this.description?this.description:''
      description=description.replaceAll(('\n'), ('<br><br>'))
      this.$refs.description.innerHTML=description
    },
  }
};
</script>

<style lang="css" >
  /*Expandable Box*/
  .expandable-box {
    border: 3px solid lightgray;
    border-radius:5px;
    margin: 1em auto;
    font-family: "PBS Sans", sans-serif;
  }

  .title-box {
    background-color: lightgray;
    cursor: pointer;
    text-align: left;
    width:100%
  }

  .title-box h3{
    font-size:1.7rem;
  }

  .description-box {
    background-image: url('../assets/art/gamestage.png');
    background-size: cover;
    text-align: left;
    padding: 1em;
    max-height:300px;
    overflow:auto;

  }
  .description-box p{
    color:black;
    font-size:1.1rem;
  }

</style>
